// extracted by mini-css-extract-plugin
export const title = "Home-module--title--1wTVL";
export const top_blue = "Home-module--top_blue--2CgX0";
export const insights = "Home-module--insights--3lVfN";
export const bouncy = "Home-module--bouncy--3cC0o";
export const pop = "Home-module--pop--3aulu";